/**
 * Bundled Simber Sounds “Chill Simple Lofi” loops.
 * Puzzle play and the home page use separate playlists and pick a track at random.
 */
export const PUZZLE_BGM_TRACKS = [
    {
        url: require("../../assets/sounds/music/Smb_CSL_Chill_Piano_Melo_56_G.wav"),
        name: "Chill piano",
    },
    {
        url: require("../../assets/sounds/music/Smb_CSL_Low_Ambient_Syn_Pad_58_Ab.wav"),
        name: "Sleepy pad",
    },
    {
        url: require("../../assets/sounds/music/Smb_CSL_High_Melo_EPiano_54_F.wav"),
        name: "Sleepy electric piano",
    },
];

export const HOME_BGM_TRACKS = [
    {
        url: require("../../assets/sounds/music/Smb_CSL_Clean_Chill_EPiano_70_Ab.wav"),
        name: "Chill electric piano",
    },
    {
        url: require("../../assets/sounds/music/Smb_CSL_Relaxing_Piano_Melo_70_Ab.wav"),
        name: "Relaxing piano",
    },
    {
        url: require("../../assets/sounds/music/Smb_CSL_Sleepy_Melody_Guitar_56_Gm.wav"),
        name: "Sleepy guitar",
    },
];
